const Urls  = {
    // baseUrl:'https://newsoft.delhitech.in/api'
    baseUrl:'https://kiaraapay.com/production',
    baseUrlPostLogin:'https://kiaraapay.com/web/production',
}

export {Urls}

